---
id: company-service
title: Company service
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - company
  - microservice
  - enrichment
---

## Product Overview

### Who it serves

This microservice supports resume and job workflows that need structured company information sourced from third-party data.

### Primary workflow

Clients submit a company lookup request, the service enqueues the work for background processing, and a consumer endpoint processes the queue task to fetch and persist company data.

### Business rules

Requests must include valid company identifiers, and user-owned resume checks are enforced before queueing work.

### Outcomes

Company search records and enriched company details are persisted for downstream resume and job post experiences.

### Out of scope

This service does not render UI, perform analytics, or run end-user search experiences directly.

### API documentation

[Internal API Documentation](https://wiki.rezi.ai/apis/company-service-api-docs)

## Technical Overview

### Architecture flow

Routes in `apps/micro-services/company-service/pkg/api/routes/routes.go` expose `/v1/companies` endpoints that hand off to `CompanyController` and `Company` service logic.

### Entry points

- `CompanyController.CompanyInfoAddToQueue`, `CompanyController.CompanyQueueConsume`, and `CompanyController.JobCompanyInfoAddToQueue` in `apps/micro-services/company-service/pkg/api/controllers/company.go` handle the request lifecycle.
- The OpenAPI spec generator entry point is `apps/micro-services/company-service/cmd/spec/main.go`.

### Key modules

Queue orchestration and enrichment logic live in `apps/micro-services/company-service/pkg/services/company.go`, with Firestore repositories under `apps/micro-services/company-service/pkg/repo/nosql/firestore`.

### Data sources and sinks

The service stores company search documents in Firestore, dispatches Cloud Tasks for enrichment, and updates related job posts through a data processor caller.

### Integrations and side effects

It integrates with Firebase Auth, Google Cloud Tasks, and Crunchbase via the caller layer in `apps/micro-services/company-service/pkg/services/callers`.

### Constraints and risks

Queue configuration and external API keys are required for enrichment to succeed, and malformed requests are rejected before queueing.

## Changelog

- 2026-02-03: Can have custom token
- 2026-01-30: Added the OpenAPI spec generator entry point.
- 2026-01-30: Initial documentation.
